module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/saas-sketch-5-ea1b785d0333dae476dd0afe184821b3.svg";